class GroupProductChart extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()

    this.setClipPath = this.setClipPath.bind(this)

    window.addEventListener('resize', this.setClipPath)
    this.setClipPath()

    this.onChartShow = this.onChartShow.bind(this)
    this.listeners.add(document, 'chartGroupVisible', this.onChartShow)
  }

  setupListeners () {
    super.setupListeners()

    this.onGroupEnter = this.onGroupEnter.bind(this)

    this.els.group.elements.forEach((el) => {
      this.listeners.add(el, 'mouseenter', this.onGroupEnter)
    })

    this.externalEls.group.elements.forEach((el) => {
      this.listeners.add(el, 'mouseenter', this.onGroupEnter)
    })

    window.BAO.eventBus.addEventListener(
      window.BAO.EVENTS.PRODUCT_CHART_ACTIVATE,
      (event) => this.onGroupEnter(event.detail),
    )
  }

  onChartShow () {
    if (this.classList.contains('prd-Chart-shown')) return

    if (!this.classList.contains('prd-Chart-shown')) {
      this.sendGA4Event()
    }

    const addVisibleAndActiveClass = (elements) => {
      elements.forEach((group, index) => {
        const delay = (index + 1) * 600

        setTimeout(() => {
          group.classList.add(group.dataset.activeClass)
          group.classList.add(group.dataset.visibleClass)
          if (!this.classList.contains('prd-Chart_Desktop')) return

          setTimeout(() => {
            group.classList.add(group.dataset.loadedClass)

            // If it's not the last group, remove the activeClass after 600ms
            if (index !== elements.length - 1) {
              group.classList.remove(group.dataset.activeClass)
            }
          }, 600)
        }, delay)
      })
    }

    const addVisibleAndActiveClassLabels = (elements) => {
      const groups = {}

      elements.forEach((button) => {
        const group = button.getAttribute('data-group')
        if (!groups[group]) {
          groups[group] = []
        }
        groups[group].push(button)
      })

      const groupKeys = Object.keys(groups).reverse()

      groupKeys.forEach((groupKey, index) => {
        const delay = (index + 1) * 800
        const groupButtons = groups[groupKey]

        setTimeout(() => {
          groupButtons.forEach((button) => {
            button.classList.add(button.dataset.activeClass)
            button.classList.add(button.dataset.visibleClass)

            setTimeout(() => {
              button.classList.add(button.dataset.loadedClass)

              button.classList.remove(button.dataset.activeClass)
            }, 800)
          })
        }, delay)
      })
    }

    const { elements: internalGroups } = this.els.group || {}
    const { elements: externalGroups } = this.externalEls.group || {}

    const reversedInternalGroups = internalGroups.slice().reverse()

    const totalGroups = internalGroups?.length || 0
    const totalDelay = totalGroups * 600

    // Start the process of adding visible and active classes
    setTimeout(() => {
      if (this.classList.contains('prd-Chart_Desktop')) {
        // eslint-disable-next-line no-undef
        addVisibleAndActiveClass(reversedInternalGroups)
      }

      addVisibleAndActiveClassLabels(externalGroups)
    }, 600)

    // Delay adding 'prd-Chart-loaded' class until after all groups are processed
    setTimeout(() => {
      this.classList.add('prd-Chart-loaded')
    }, 600 + totalDelay)

    this.classList.add('prd-Chart-shown')
  }

  onGroupEnter (e) {
    let group = e

    if (group?.target?.dataset?.group) {
      group = e.target.dataset.group
    }

    const toggleClass = (elements) => {
      elements?.forEach((el) => {
        const elDataGroup = parseInt(el.dataset.group)
        group = parseInt(group)

        el.classList.toggle(el.dataset.activeClass, elDataGroup === group)
      })
    }

    const { elements: internalElements } = this.els.group || {}
    const { elements: externalElements } = this.externalEls.group || {}

    toggleClass(internalElements)
    toggleClass(externalElements)
  }

  sendGA4Event () {
    const ga4EventData = {
      event: 'product_chart_viewed',
      chart: {
        page_type: this.dataset.pageType,
        page_title: this.dataset.pageTitle,
      },
    }

    window.dataLayer = window.dataLayer || []
    window.dataLayer.push(ga4EventData)
  }

  setClipPath () {
    const width = this.offsetWidth
    const halfWidth = width / 2
    const thickness = window.BAO.MediaBreakpoints.isSm ? 50 : 35
    const outerRadius = halfWidth
    const innerRadius = (width - thickness * 2) / 2

    const clipPath = `path("M 0, ${halfWidth} A ${outerRadius} ${outerRadius} 0 0 1 ${width} ${halfWidth} L ${
      width - thickness
    } ${halfWidth} A ${innerRadius} ${innerRadius} 0 0 0 ${thickness} ${halfWidth} A ${innerRadius} ${innerRadius} 0 0 0 ${
      width - thickness
    } ${halfWidth} L ${width} ${halfWidth} A ${outerRadius} ${outerRadius} 0 0 1 0 ${halfWidth} Z")`

    this.style.setProperty('--Clip_Path', clipPath)
  }
}

if (!customElements.get('group-product-chart')) {
  customElements.define('group-product-chart', GroupProductChart)
}
